class CartSummary extends HTMLElement {
    static ELEMENT_NAME = 'cart-summary'

    $elements = {
        quantityInputs: null,
        form: null,
    }

    constructor() {
        super()

        this.$elements.form = this.querySelector('form')
        this.$elements.quantityInputs = this.querySelectorAll('quantity-input')

        this.$elements.quantityInputs.forEach(input => input.addEventListener('quantity-changed', this.handleQuantityChange.bind(this)))
    }

    /**
     * EVENTS
     */

    handleQuantityChange(e) {
        this.$elements.form.requestSubmit()
    }
}

customElements.define(CartSummary.ELEMENT_NAME, CartSummary);